import type { RelatedEntitySheet } from '../utilities/useRelatedEntitiesWaterfalls';

// A registered child sheet is safe to reference only while that same render mounts it.
export const getActiveRelatedEntitySheets = (
  childrenSheets: Record<number, RelatedEntitySheet[]>,
  shouldRunRelatedEntitiesWaterfall: boolean
): RelatedEntitySheet[] =>
  shouldRunRelatedEntitiesWaterfall ? Object.values(childrenSheets).flat() : [];

interface ShouldReleaseFullWaterfallSkeletonParams {
  combinedIsLoading: boolean;
  hasUnavailableCompanyFromUrl: boolean;
  isInitializationUnavailable: boolean;
  selectedCompanyId?: number;
}

export const shouldReleaseFullWaterfallSkeleton = ({
  combinedIsLoading,
  hasUnavailableCompanyFromUrl,
  isInitializationUnavailable,
  selectedCompanyId,
}: ShouldReleaseFullWaterfallSkeletonParams): boolean => {
  if (hasUnavailableCompanyFromUrl) {
    return true;
  }
  if (combinedIsLoading) {
    return false;
  }
  return selectedCompanyId == null || isInitializationUnavailable;
};

interface ShouldFetchRelatedEntityCapTableDetailParams {
  childCapTableIds: number[];
  isCaptableDetailLoading: boolean;
  isChildrenCapTablesLoading: boolean;
  loadedCaptableId?: number;
  selectedCaptableId?: number;
}

export const shouldFetchRelatedEntityCapTableDetail = ({
  childCapTableIds,
  isCaptableDetailLoading,
  isChildrenCapTablesLoading,
  loadedCaptableId,
  selectedCaptableId,
}: ShouldFetchRelatedEntityCapTableDetailParams): boolean =>
  selectedCaptableId != null &&
  !isChildrenCapTablesLoading &&
  !isCaptableDetailLoading &&
  loadedCaptableId !== selectedCaptableId &&
  childCapTableIds.includes(selectedCaptableId);
